import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// pega path e slug ANTES de renderizar
const path = window.location.pathname;
const pathParts = path.split('/').filter(Boolean);
const isTestRoute = pathParts[0] === 'teste';

if (isTestRoute) {
  // 👉 Instagram: carrega APENAS o AppTest
  import("./Teste")
    .then(({ default: AppTest }) => {
      root.render(
        <React.StrictMode>
          <AppTest />
        </React.StrictMode>
      );
    })
    .catch((err) => {
      console.error("Erro carregando AppTest:", err);
      root.render(
        <div
          style={{
            backgroundColor: "#000",
            color: "#f00",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
            textAlign: "center",
          }}
        >
          Erro ao carregar versão de teste.
        </div>
      );
    });
} else {
  // 👉 Qualquer outro navegador: carrega o App normal
  import("./App")
    .then(({ default: App }) => {
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
    })
    .catch((err) => {
        const msg =
      err instanceof Error
        ? err.message
        : typeof err === "string"
        ? err
        : JSON.stringify(err);

         const dump = JSON.stringify(
        err,
        Object.getOwnPropertyNames(err),
        2
      );

      root.render(
        <div
          style={{
            backgroundColor: "#000",
            color: "#f00",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
            textAlign: "center",
          }}
        >
          Erro ao carregar o app.<br/>
          {msg}
          <br/>
          <br/>
          {dump}
        </div>
      );
    });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();